var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"whs",attrs:{"id":"whs"}},[(_vm.isError('Access denied'))?_c('Error',{attrs:{"code":"Access denied"}}):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }